import React, { useEffect, useState, useRef } from 'react';
import { Section } from './ui/Section';
function AccordionItem({
  question,
  answer,
  isOpen,
  onToggle
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen]);
  return <div className="bg-white border border-neutral-200 rounded-xl overflow-hidden shadow-sm" data-id="element-115">
      <button className="w-full text-left p-6 flex items-center justify-between focus:outline-none hover:bg-neutral-50 transition-colors" onClick={onToggle} aria-expanded={isOpen} data-id="element-116">
        <span className="font-heading font-bold text-lg pr-8 text-brand-title" data-id="element-117">
          {question}
        </span>
        <span className={`text-brand-cta text-2xl transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-118">
          +
        </span>
      </button>
      <div style={{
      height: `${height}px`
    }} className="overflow-hidden transition-[height] duration-300 ease-in-out" data-id="element-119">
        <div ref={contentRef} data-id="element-120">
          <div className="p-6 pt-0 font-body text-brand-text leading-relaxed border-t border-neutral-100 mt-2" data-id="element-121">
            {answer}
          </div>
        </div>
      </div>
    </div>;
}
export function FAQ() {
  const faqs = [{
    q: '❓ 1 — ¿Cómo recibo el pack después de comprar?',
    a: 'Recibes un email con acceso inmediato a todos los PDFs en menos de 5 minutos.'
  }, {
    q: '❓ 2 — ¿Funciona para cualquier tipo de piel?',
    a: 'Sí. El sistema incluye diagnóstico personalizado para piel seca, grasa, mixta, sensible o madura.'
  }, {
    q: '❓ 3 — ¿Tengo que comprar productos nuevos para aplicarlo?',
    a: 'No. El Tomo 1 empieza por auditar lo que ya tienes. En muchos casos el resultado es eliminar productos, no comprar más.'
  }, {
    q: '❓ 4 — ¿Es editable? ¿Puedo imprimirlo?',
    a: 'Es 100% PDF. Puedes imprimirlo, guardarlo en tu móvil o tablet y consultarlo cuando quieras.'
  }, {
    q: '❓ 5 — ¿Los 3 bonos están en todas las ofertas?',
    a: 'Sí. Los 3 bonos están incluidos tanto en la Oferta Base (13.99€) como en la Oferta Completa (19.99€).'
  }, {
    q: '❓ 6 — ¿Qué diferencia hay entre las dos ofertas?',
    a: 'La Oferta Completa incluye PIEL SIN FILTROS™, el Sistema de Alta Potencia con rutinas avanzadas, uso de dispositivos y resultados de clínica en casa.'
  }, {
    q: '❓ 7 — ¿Funciona si tengo más de 40 años?',
    a: 'Absolutamente. El Tomo 5 está diseñado específicamente para adaptar la rutina a los cambios de piel por edad.'
  }, {
    q: '❓ 8 — ¿Qué diferencia tiene esto de seguir un canal de YouTube de skincare?',
    a: 'EL AUDITOR DE SKINCARE™ no es contenido genérico. Es un sistema secuencial que empieza por TU piel y TUS productos, no por consejos generales.'
  }, {
    q: '❓ 9 — ¿En qué moneda pago?',
    a: 'En euros (€). Pago 100% seguro con tarjeta de crédito, débito o PayPal.'
  }, {
    q: '❓ 10 — ¿Tiene garantía?',
    a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section variant="alt" data-id="element-122">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-12 text-brand-title" data-id="element-123">
        ❓ PREGUNTAS FRECUENTES
      </h2>
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-124">
        {faqs.map((faq, i) => <AccordionItem key={i} question={faq.q} answer={faq.a} isOpen={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-125" />)}
      </div>
    </Section>;
}